import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Space, Table } from "antd";

export function PostTypeList({
  data,
  loading,
  filter,
  onFilterChange,
  onEdit,
  onDelete,
}) {
  const columns = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: 70,
      align: "center",
    },
    {
      title: "Tên loại tin tức",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Hành động",
      key: "action",
      width: 150,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space size="small">
          <Button
            type="text"
            size="small"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
            style={{ color: "green" }}
          />
          <Popconfirm
            title="Bạn có chắc muốn xóa?"
            onConfirm={() => onDelete(record._id)}
            okText="Có"
            cancelText="Không"
          >
            <Button type="text" danger size="small" icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      scroll={{ x: 1200 }}
      columns={columns}
      dataSource={
        data.length > 0 &&
        data.map((item, idx) => ({
          ...item,
          ...(filter && {
            key: (filter.page - 1) * filter.limit + idx + 1,
          }),
        }))
      }
      loading={loading}
      rowKey="_id"
      pagination={false}
      size="middle"
    />
  );
}
